import { Pipe, PipeTransform } from '@angular/core';
import {CollegeProfession} from '../components/college-info/college-info.component';

@Pipe({
  name: 'collegeProfessionSort'
})
export class SortPipe implements PipeTransform {

  transform(array: CollegeProfession[], args?: any): CollegeProfession[] {
    array.sort((a: CollegeProfession, b: CollegeProfession) => {
      const tempCmp = this.professionCodeCompare(a.professionCode.substring(0, 2), b.professionCode.substring(0, 2));
        if ( tempCmp === -1) {
          return -1;
        } else if ( tempCmp === 1) {
          return 1;
        } else {
          if (a.professionName < b.professionName) {
            return -1;
          } else if (a.professionName > b.professionName) {
            return 1;
          } else {
            return 0;
          }
        }
      // }
    });
    return array;
  }

  professionCodeCompare(a: string, b: string) {
    let numA: number, numB: number;
    const professionCodes: ProfessionCode[] = new Array<ProfessionCode>();
    professionCodes.push(new ProfessionCode(0, '5B'));
    professionCodes.push(new ProfessionCode(1, '6M'));
    professionCodes.push(new ProfessionCode(2, '6D'));
    for (let i = 0; i < professionCodes.length; i++) {
      if (professionCodes[i].getChars() === a) {
        numA = professionCodes[i].getId();
      }
      if (professionCodes[i].getChars() === b) {
        numB = professionCodes[i].getId();
      }
    }
    if (numA < numB) {
      return -1;
    } else if (numA > numB) {
      return 1;
    }
    return 0;
  }
}

export class ProfessionCode {
  id: number;
  chars: string;

  constructor (id: number, chars: string) {
    this.id = id;
    this.chars = chars;
  }

  getChars() {
    return this.chars;
  }

  getId() {
    return this.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/sort/college-profession.sort.ts